"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactSvg = require("react-svg");
var _Anchor = _interopRequireDefault(require("../../Atoms/Anchor"));
require("./PromoCode.scss");
var PromoCode = function PromoCode(_ref) {
  var promoCode = _ref.promoCode,
    details = _ref.details,
    showPromoCodeDetails = _ref.showPromoCodeDetails,
    removePromoCode = _ref.removePromoCode,
    closeIcon = _ref.closeIcon;
  var getPromoCodeDetails = function getPromoCodeDetails(event) {
    event.preventDefault();
    event.stopPropagation();
    showPromoCodeDetails();
  };
  return _react.default.createElement("section", {
    className: "promoCode center-xs",
    "data-locator": "promo-tag-container-" + promoCode
  }, _react.default.createElement(_reactSvg.ReactSVG, {
    className: "icon",
    src: closeIcon,
    onClick: removePromoCode,
    "data-locator": "image-promo-tag-" + promoCode
  }), _react.default.createElement("span", {
    "data-locator": "promo-tag-name-" + promoCode
  }, promoCode), _react.default.createElement(_Anchor.default, (0, _extends2.default)({
    handleLinkClick: getPromoCodeDetails
  }, {
    elementLocator: "link-promo-tag-details-" + promoCode
  }), details));
};
PromoCode.defaultProps = {
  promoCode: '',
  details: '',
  showPromoCodeDetails: function showPromoCodeDetails() {
    /* default showPromoCodeDetails handler */
  },
  removePromoCode: function removePromoCode() {
    /* default removePromoCode handler */
  },
  closeIcon: '/static/images/close.svg'
};
var _default = PromoCode;
exports.default = _default;
module.exports = exports["default"];